import React, {useEffect,useState,useRef} from "react";
import "../../../Components/ProductRegal/ProductRegal.scss";
import {useHistory} from "react-router-dom";
import { PlayCircleOutlined } from '@ant-design/icons';
import "./TextDesktop.scss";



function limitText(txt,length) {
    if(txt?.length>length){
        return txt.substr(0,length)+" ... "
    }else {
        return txt
    }
}

function TextDesktop({item}) {
    const history = useHistory();

    let txt = "سایت داروخانه دکتر حمزوی، سایتی جامع برای مشاوره، اطلاع رسانی، آموزش و فروش اینترنتی محصولات داروخانه ای با مجوز رسمی معاونت غذا و دارو می باشد. سایت دکتر حمزوی در جهت بهبود خدمات رسانی، افزایش آگاهی از انواع محصولات دارویی و آرایشی بهداشتی و پاسخگویی به سوالات شما فراهم گردیده است. ارائه کلیه اطلاعات لازم در خصوص هر محصول به شما امکان انتخاب درست و خرید آسان و مطمئن را میدهد."

    return(
        <div className="text-desktop-container">

            <div className="text-desktop-list">

                {item?.items?.map(i=>{
                    return(
                        <div className="text-desktop-container-item" >
                            <span>{i.title}</span>
                            <p>
                                {limitText(i.text,250)}
                            </p>
                        </div>
                    )
                })}



            </div>

        </div>

    )
}

export {TextDesktop};
